import { capitalize } from "lodash";
import { useApiGet } from "../../utils/api";
import { useModal } from "../../utils/modal_launcher";
import AddIdeaModal from "./add_idea_modal";
import { IdeaCard } from "./idea_card";

const IdeaBoard = ({ trip }) => {
  const { data, unavailable } = useApiGet({ "idea-board": `/api/user/ideas/${trip.id}` });

  const addIdeaModal = useModal(AddIdeaModal, {});

  if (unavailable) {
    return unavailable;
  }

  const groups = data?.idea_groups || [];

  return (
    <div>
      <div className="d-flex align-items-center">
        <button
          className="btn btn-primary"
          onClick={() => addIdeaModal.show({ tripId: trip.id, groups })}
        >
          + Add Idea
        </button>
      </div>

      {groups.length === 0 && <div className="text-muted mt-4">No ideas yet</div>}

      {groups.map((group) => (
        <div key={group.title} className="mt-4">
          <div className="fs-26 mb-2">{capitalize(group.title)}</div>
          <div className="g-3 row row-cols-md-5 row-cols-1">
            {group.ideas.map((idea) => (
              <div className="col" key={idea.uuid}>
                <IdeaCard idea={idea} trip={trip} groups={groups} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default IdeaBoard;
